import { AppRoutesService, CumLaudeRoute, CumLaudeRouteData, RouteDef } from '@cumlaude/shared-components-menu';
import { computed, inject, Injectable, signal } from '@angular/core';
import { AuthService } from '@cumlaude/shared-authentication';
import { isUndefined } from 'lodash-es';

export type AdminRouteData = CumLaudeRouteData & {
	/**
	 * Of deze route alleen zichtbaar is voor developers
	 */
	developer?: boolean;
};

@Injectable({
	providedIn: 'root',
})
export class AdminRoutesService extends AppRoutesService<AdminRouteData> {
	override readonly routeConfig = signal(this.router.config);
	private readonly authService = inject(AuthService);

	override readonly activeAuthorisedRoutes = computed(() => {
		const routes = this.routes();
		const developer = this.authService.developer();
		return this.getAuthorizedRoutes(routes, developer);
	});

	override isRoot(_route: CumLaudeRoute<AdminRouteData>): boolean {
		return false;
	}

	override hasName(data: AdminRouteData): boolean {
		return !isUndefined(data.name);
	}

	private getAuthorizedRoutes(routes: RouteDef<AdminRouteData>[], developer: boolean) {
		return routes.filter((route: RouteDef<AdminRouteData>) => !(route.routeData?.developer ?? false) || developer);
	}
}
